import WhatsappAction from "../whatsapp/whatsapp_action";
import HeroSC from "./hero.styles";
import HeroImages from "./hero_images";

const HeroContent = () => {
    return <div className="hero-content-holder">
        <div className="brand-name">
            Welcome to Niraatanka
        </div>

        <div className="description">
            <h1>
                We offer professional and confidential psychological counselling services for students, professionals, and individuals.
            </h1>
            <h1>
                Our evidence-based approach integrates CBT, DBT, and mindfulness techniques to promote resilience and long-term wellbeing.

            </h1>
            <h1>
                We provide a safe, non-judgmental space focused on personal growth, emotional regulation, and mental health awareness. In-person and online sessions available.

            </h1>
        </div>
        {
            window.screen.width < 800 ? <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                <WhatsappAction showNumber={true} />
            </div> : <div style={{ display: "flex", flexDirection: "row" }}>
                <WhatsappAction />
            </div>
        }
    </div>
}

const ImageGallery = () => {
    return <div className="image-gallery">
        <HeroImages />
    </div>
}

const Hero = () => {
    const isMobile = window.screen.width < 800;
    return <HeroSC>
        <div className="hero-holder">
            {isMobile ? <ImageGallery /> : <HeroContent />}
            {isMobile ? <HeroContent /> : <ImageGallery />}
        </div>
    </HeroSC>
}

export default Hero;
